export default {
    methods: {
        createEventProxy(eventName){
            const vm = this;

            return function() {
                vm.$emit(eventName, ...arguments);
            };
        },
        createFilteredEventProxy(eventName, shouldFireFn) {
            const vm = this;
            const proxy = vm.createEventProxy(eventName);
            
            return function() {
                const args = arguments;
                const shouldFire = shouldFireFn.call(vm, ...args);
                
                if(shouldFire){
                    proxy.call(vm, ...args);
                }
            };
        }
    }
};